// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_THEME_MODE = '@customization/SET_THEME_MODE';

export const LOGGED_IN = 'LOGGED_IN';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';

export const SET_METRICS_FILTERS = '@metrics/SET_FILTERS';
export const SET_METRICS_HAS_APPLIED = '@metrics/SET_HAS_APPLIED';

export const SET_COMPARISON_FILTERS = '@comparison/SET_FILTERS';

export const SET_ACCURACY_RANKING_FILTERS = '@accuracyRanking/SET_FILTERS';
export const SET_ACCURACY_RANKING_HAS_APPLIED = '@accuracyRanking/SET_HAS_APPLIED';
